// 各包 words 按需动态加载，与 packages/index.js 保持一致的懒加载模式。
// prettier-ignore
const loaders = {
  echo:    () => import(/* webpackChunkName:"chunk-words-echo"    */ './echo.js'),
  joychat: () => import(/* webpackChunkName:"chunk-words-joychat" */ './joychat.js'),
  joyu:    () => import(/* webpackChunkName:"chunk-words-joyu"    */ './joyu.js'),
  kiko:    () => import(/* webpackChunkName:"chunk-words-kiko"    */ './kiko.js'),
  vava:    () => import(/* webpackChunkName:"chunk-words-vava"    */ './vava.js'),
  vibeo:   () => import(/* webpackChunkName:"chunk-words-vibeo"   */ './vibeo.js'),
}

const cache = {}

/**
 * 预加载指定包的 words 模块并写入 cache。
 * 在应用挂载前（main.js IIFE 中）调用，确保首次渲染时 getWords 能同步返回数据。
 */
export async function loadWords(packageName) {
  if (!loaders[packageName] || cache[packageName]) return
  try {
    const mod = await loaders[packageName]()
    cache[packageName] = mod.default
  } catch (e) {
    console.warn('loadWords error:', packageName, e)
  }
}

/**
 * 同步返回指定包的 words 对象（需已通过 loadWords 预加载）。
 */
export function getWords(packageName) {
  const tempWordsObj = {}
  try {
    const wordsMap = cache[packageName]
    if (wordsMap) {
      Object.keys(wordsMap).forEach((wordKey) => {
        tempWordsObj[wordKey] = wordsMap[wordKey]()
      })
    }
  } catch (e) {
    console.warn('text error')
  }
  return tempWordsObj
}

export default getWords
